/* lab-rise.js — band kicker, name, caps and the one-off display headings rise word by word
   on first view; images, step plates, row rules and footer columns are marked .is-in to reveal (DIRECTION.md §6).
   Each word becomes <span class="rise"><span>word</span></span>; a
   word that spans the alt-name's roman/italic runs keeps its .r/.i pieces inside the
   one wrapper, so the word stays unbreakable. An IntersectionObserver adds .is-in
   once and lab-motion.css runs the transition. The hero name's settle (interaction 3)
   is dropped in favour of the rise, so the two never stack. The dateline is marked, not
   wrapped: it lands as one stamp, and its <b> year never meets the word wrapper. */
(() => {
  const RISE = '.band__kicker, .band__name, .band__caps, .field-header__heading, .pband__title, .band__title, .ladder__name, .lot-next__name, .footer-news__heading';
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (!matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  // marked is-in only, no wrapping: images reveal, rules draw, footer columns slide
  const MARK = '.band__media, .images, .lead__media, .band__dateline, .step__figure, .rows, .steps, .footer-index';
  const names = document.querySelectorAll(RISE);
  const marks = document.querySelectorAll(MARK);
  if (!names.length && !marks.length) return;
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (!e.isIntersecting) continue;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    }
  }, { rootMargin: '0px 0px -35% 0px' }); // fires in the reading zone, not at the bottom edge:
  // a line that enters at the edge rose while the eye was still above it (owner, 2026-10-08)
  const piece = (text, cls) => {
    if (!cls) return text;
    const s = document.createElement('span');
    s.className = cls;
    s.textContent = text;
    return s;
  };
  for (const mark of marks) io.observe(mark);
  for (const name of names) {
    name.classList.remove('settle');
    const root = name.querySelector('.alt-name') || name;
    if (root.querySelector(':scope > :not(.r):not(.i)')) { name.classList.add('is-in'); continue; } // unknown markup: show static
    // words: arrays of [text, cls] pieces; a space ends a word
    const words = [[]];
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (w.nextNode()) {
      const cls = w.currentNode.parentElement === root ? '' : w.currentNode.parentElement.className;
      for (const part of w.currentNode.nodeValue.split(/(\s+)/)) {
        if (!part) continue;
        if (/^\s+$/.test(part)) { if (words.at(-1).length) words.push([]); continue; }
        words.at(-1).push([part, cls]);
      }
    }
    root.replaceChildren();
    let i = 0;
    for (const word of words) {
      if (!word.length) continue;
      if (i) root.append(' ');
      const outer = document.createElement('span');
      outer.className = 'rise';
      outer.style.setProperty('--i', i++);
      const inner = document.createElement('span');
      inner.append(...word.map(([t, c]) => piece(t, c)));
      outer.append(inner);
      root.append(outer);
    }
    io.observe(name);
  }
})();
